import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import React, { FC } from 'react';
import { TextFieldProps } from '@material-ui/core/TextField/TextField';
import { Email } from '@material-ui/icons';

export const EmailInput: FC<TextFieldProps> = ({ ...rest }) => (
  <TextField
    {...rest}
    variant="filled"
    margin="dense"
    fullWidth
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Email />
        </InputAdornment>
      ),
    }}
  />
);
